import { makeStyles } from "@mui/styles";

const teamStyle = makeStyles((theme) => ({
  boldText: {
    fontWeight: "600 !important",
    fontSize: "2rem !important",
  },
  hrLine: {
    height: "3px",
    width: "60px",
    backgroundColor: "#008374",
    margin: "0px auto",
  },
  teamCard: {
    textAlign: "center",
    background: "#fff",
    borderRadius: "10px",
    overflow: "hidden",
    padding: "15px",
    boxShadow: "0px 2px 25px rgba(0, 0, 0, 0.1)",
    "&.MuiBox-root .MuiTypography-h6": {
      fontSize: "20px !important",
      fontWeight: "700 !important",
    },
    "&.MuiBox-root .MuiTypography-body2": {
      color: "#6c757d",
      fontSize: "14px !important",
      marginTop: "1px",
    },
    "&.MuiBox-root .memberLinks": {
      marginTop: "15px",
      marginBottom: "0px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
    },

    "&.MuiBox-root .MuiLink-root": {
      color: "#a2a2a2",
      transition: "0.3s",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "1px solid #bbbbbb",
      cursor: "pointer",
      "&:hover": {
        color: "#008374 !important",
        borderColor: "#008374 !important",
      },
    },
    "&.MuiBox-root .MuiLink-root .MuiSvgIcon-root": {
      fontSize: "22px !important",
    },
  },
}));

export default teamStyle;
